export default __webpack_public_path__ + "static/media/17.d4994428.webp";